import merge from 'lodash/merge'

export default {
  updateSettings: function({ commit, getters }, payload) {
    commit('UPDATE_NOTICEBAR', merge({}, getters.settings, payload))
  },
  save: function({ state, commit, dispatch, getters, rootGetters }, payload) {
    const d = new Date()
    d.setTime(d.getTime())
    const expiresDateString = d.toUTCString()
    commit('SET_SETTINGS_TIMESTAMP', expiresDateString)

    const blobID = 'concilio--site-settings'
    const blobCurrentData = rootGetters['blob/get'](blobID)
    const noticebarData = getters.settings

    const blobData = merge({}, blobCurrentData, {
      noticebar: noticebarData
    })

    return dispatch('blob/save', { blobID: blobID, blobData: blobData }, { root: true })
  },
  init: function({ state, dispatch, commit, rootGetters }, payload) {
    const blobData = rootGetters['blob/get']('concilio--site-settings')
    const storeSettings = (Object.keys(blobData).length > 0 && Object.keys(blobData).includes('noticebar')) ? blobData.noticebar : state.defaultSettings

    commit('UPDATE_NOTICEBAR', storeSettings)
  }
}
